import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  Image,
  Text,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import LogoSvg from '../../assets/logo.svg';
import { ColorModeSwitcher } from '../ColorModeSwitcher';

interface MarketingHeaderProps {
  showDemoButton?: boolean;
  onDemoClick?: () => void;
  /**
   * Overrides the demo button label so a page whose CTA is worded differently
   * asks for the same thing here. Defaults to the site-wide "Request Demo".
   */
  demoButtonLabel?: string;
}

export function MarketingHeader({
  showDemoButton = true,
  onDemoClick,
  demoButtonLabel = 'Request Demo',
}: MarketingHeaderProps) {
  const navigate = useNavigate();

  return (
    <Box
      as="nav"
      position="sticky"
      top={0}
      zIndex={10}
      bg={'bg-canvas'}
      backdropFilter="blur(10px)"
      borderBottom="1px"
      borderColor="border-default"
    >
      <Container maxW="7xl" py={4}>
        <Flex justify="space-between" align="center">
          <HStack spacing={2} cursor="pointer" onClick={() => navigate('/')}>
            <Image src={LogoSvg} alt="TaskEye Logo" boxSize="32px" />
             <Text fontSize="xl" fontWeight="bold" color="brand.500">
                TaskEye
             </Text>
          </HStack>
          <HStack spacing={4}>
            <ColorModeSwitcher />
            <Button
              variant="ghost"
              onClick={() => navigate('/client/login')}
              display={{ base: 'none', md: 'inline-flex' }}
            >
              Sign In
            </Button>
            {/* Sized down on mobile because demoButtonLabel is caller-supplied and
                can be considerably longer than the default: at base the logo and
                this button are the only things competing for a ~320px bar. */}
            {showDemoButton && onDemoClick && (
              <Button
                onClick={onDemoClick}
                colorScheme="brand"
                size={{ base: 'sm', md: 'md' }}
              >
                {demoButtonLabel}
              </Button>
            )}
            {showDemoButton && !onDemoClick && (
              <Button
                onClick={() => navigate('/#demo-form')}
                colorScheme="brand"
                size={{ base: 'sm', md: 'md' }}
              >
                {demoButtonLabel}
              </Button>
            )}
          </HStack>
        </Flex>
      </Container>
    </Box>
  );
}
